const FSRB_SWATCHES_PROXY_PATH = '/apps/efg-app';
const FSRB_SWATCHES_STORE_CODE = 'EFG';
const FSRB_SWATCHES_MYSHOPIFY = 'fsrb1';
const FSRB_SWATCHES_STOREFRONT_ACCESS_TOKEN = '15789734934a86e4a8c59f34bcbb67ff';

const fsrbSwatchesDiv = document.querySelector('.fsrb-swatches');

function onSwatchDropdownClick() {
    let sibling = this.nextElementSibling;
    while (sibling) {
        sibling.classList.toggle('fsrb-swatches-hide');
        sibling = sibling.nextElementSibling;
    }
}

fetch(`${FSRB_SWATCHES_PROXY_PATH}/swatches?store=${FSRB_SWATCHES_STORE_CODE}&id=${fsrbSwatchesDiv.dataset.productId}`)
    .then(response => response.json())
    .then(swatchGroups => {

        const getProductGids = ids => {
            ids.forEach((o, i, a) => a[i] = 'gid://shopify/Product/' + a[i]);
            return ids;
        }

        const productsQuery = productIds => `{
            nodes(ids: ${JSON.stringify(getProductGids(productIds))}) {
                ... on Product {
                    id
                    handle
                    images(first: 1) {
                        edges {
                            node {
                                src
                            }
                        }
                    }
                    priceRange {
                        minVariantPrice {
                            amount
                        }
                    }
                }
            }
        }`;

        const qglOptions = (argument) => {
            return {
                async: true,
                crossDomain: true,
                method: 'POST',
                headers: {
                    'X-Shopify-Storefront-Access-Token': FSRB_SWATCHES_STOREFRONT_ACCESS_TOKEN,
                    'Content-Type': 'application/graphql',
                },
                body: productsQuery(argument)
            };
        }

        const GRAPHQL_URL = 'https://' + FSRB_SWATCHES_MYSHOPIFY + '.myshopify.com/api/2020-07/graphql.json';

        const productIds = [];

        for (const swatchGroup of swatchGroups) {
            for (const product of swatchGroup.products) {
                productIds.push(product.id);
            }
        }

        fetch(GRAPHQL_URL, qglOptions(productIds))
            .then(res => res.json())
            .then(dataFromGql => {

                for (let i = swatchGroups.length - 1; i >= 0; i--) {
                    for (let j = swatchGroups[i].products.length - 1; j >= 0; j--) {

                        const product = swatchGroups[i].products[j];

                        const getDecodedId = base64Gid => {
                            let gidText = base64Gid;
                            if (! base64Gid.startsWith('gid://shopify/')) {
                                gidText = atob(base64Gid);
                            }
                            return gidText.replace('gid://shopify/Product/','').replace('gid://shopify/ProductVariant/','');
                        };
                        
                        const matchingProductFromGql = dataFromGql.data.nodes.find(node =>
                            node && node.id && getDecodedId(node.id) === product.id
                        );

                        if (matchingProductFromGql) {
                            product.handle = matchingProductFromGql.handle;
                            if (!product.image) {
                                product.image = matchingProductFromGql.images.edges[0].node.src;
                            }
                            product.price = matchingProductFromGql.priceRange.minVariantPrice.amount;
                        } else {
                            swatchGroups[i].products.splice(j, 1);
                        }
                    }
                    if (!swatchGroups[i].products.length) {
                        swatchGroups.splice(i, 1);
                    }
                }

                for (const swatchGroup of swatchGroups) {

                    swatchGroup.products.sort((a, b) => {
                        if (swatchGroup.type === 'dropdown') {
                            if (a.id === fsrbSwatchesDiv.dataset.productId) {
                                return -1;
                            } else if (b.id === fsrbSwatchesDiv.dataset.productId) {
                                return 1;
                            }
                        }
                        return a.price - b.price;
                    });

                    const title = document.createElement('p');
                    title.innerText = swatchGroup.title;
                    title.classList.add('fsrb-swatches-title');
                    
                    const links = document.createElement('ul');

                    if (swatchGroup.type === 'dropdown') {
                        links.classList.add('fsrb-swatches-dropdown');
                    }

                    for (const product of swatchGroup.products) {

                        const link = document.createElement('li');

                        if (product.id !== fsrbSwatchesDiv.dataset.productId) {
                            link.onclick = () => {
                                window.location = '/products/' + product.handle;
                            }
                        }

                        if (swatchGroup.type === 'dropdown') {
                            
                            const img = document.createElement('img');
                            img.src = product.image;
                            img.width = 41;
                            img.height = 41;
                            link.appendChild(img);

                            const text = document.createElement('p');
                            text.innerText = product.name;
                            link.appendChild(text);

                            if (product.id === fsrbSwatchesDiv.dataset.productId) {
                                const arrow = document.createElement('img');
                                arrow.src = 'https://cdn.shopify.com/s/files/1/0555/9527/0317/files/arrow-down.svg'
                                arrow.width = 20;
                                arrow.height = 20;
                                arrow.classList.add('fsrb-swatches-arrow');
                                link.appendChild(arrow);
                            }

                            if (product.id !== fsrbSwatchesDiv.dataset.productId) {
                                link.classList.add('fsrb-swatches-hide');
                            } else {
                                link.onclick = onSwatchDropdownClick;
                            }

                            link.classList.add('fsrb-swatches-dropdown-option');
                        
                        } else if (swatchGroup.type === 'images') {
                            
                            const img = document.createElement('img');
                            img.src = product.image;
                            img.width = 80;
                            img.height = 80;
                            link.appendChild(img);

                            link.classList.add('fsrb-swatches-image');

                        } else {

                            link.innerText = product.name;

                            link.classList.add('fsrb-swatches-button');
                        }

                        if (product.id === fsrbSwatchesDiv.dataset.productId) {
                            link.classList.add('fsrb-swatches-selected');
                        }

                        links.appendChild(link);
                    }

                    fsrbSwatchesDiv.appendChild(title);
                    fsrbSwatchesDiv.appendChild(links);
                    // fsrbSwatchesDiv.appendChild(document.createElement('br'));

                    fsrbSwatchesDiv.style.display = 'block';
                }
            })
    });